module.exports = __webpack_public_path__ + "img/Feature.016ce83a.png";